<template>
  <el-container>
    <el-header style="padding: 0px;">
      <PageTop></PageTop>
    </el-header>
    <el-container>
      <el-aside style="width: 200px; height: calc(100vh - 60px);overflow-y: auto;overflow-x: hidden;">
        <LeftMenu></LeftMenu>
      </el-aside>
      <el-main style="background-color: #F5F7F9;height: calc(100vh - 60px);overflow: auto;">
        <el-breadcrumb v-if="!Tool.isNull(openMenu)" separator="/" style="margin-bottom: 20px;">
          <el-breadcrumb-item v-for="(item, index) in openMenu" :key="index" replace
                              :to="item.children && item.children.length>0 && item.hideChildren?{path:item.path,query:$route.query}:false">
            {{item.name}}
          </el-breadcrumb-item>
        </el-breadcrumb>
        <router-view/>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import LeftMenu from './left-menu'
import PageTop from './page-top'
// import MenuTree from '../common/menu-tree'
/* eslint-disable */
export default {
  name: 'layout',
  components: { PageTop, LeftMenu },
  props: [],
  data () {
    return {
      currentUserInfo: this.$store.state.currentUserInfo,
      openMenu: [],
      treeNodeArr: [],
      // list: MenuTree
    }
  },
  async created () {
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {
    '$route.path': {
      handler: function (newVal) {
        this.treeNodeArr = []
        let treeNodeArr = this.findTreeNode(this.list, 'path', newVal, 'children', 'parent') || []
        // treeNodeArr.push({ path: '/index/home', name: '首页' })
        this.openMenu = treeNodeArr.reverse()
      },
      immediate: true
    }
  },
  methods: {
    findTreeNode (tree, key = 'id', value, children = 'children', parent = 'parent') {
      let node = this.Tool.find(tree, key, null, value)
      if (!node) {
        for (let i in tree) {
          let list = tree[i][children]
          if (list && list.length > 0) {
            let treeNodeArr = this.findTreeNode(list, key, value, children, parent)
            if (treeNodeArr) {
              this.treeNodeArr.push(tree[i])
              return this.treeNodeArr
            }
          }
        }
      } else {
        this.treeNodeArr.push(node)
        return this.treeNodeArr
      }
    }
  }
}
</script>
